import loadFittedImage from 'zoomforth_zfutils/load_fitted_image.js';

(function() {


  zfrespond.views.MediaResponseThumbnailView = Backbone.View.extend({
    
    className: 'response-thumbnail-view media-response-thumbnail-view',

    events: {
      "click": "handleEdit"
    },

    template: ZFRESPOND_JST['respond.media_response_thumbnail'],

    initialize: function(options) {
      options = options || {};
      this.percent = 0;
      this.processing = false;
      this.assetPrecursor = this.model.assetPrecursor;
      this.clickTriggersEdit = !!options.clickTriggersEdit;

      this.editing = !!options.editing;

      this.progressIconSettings = { 
        color:'#36cc29', 
        valueAttr:"data-val", 
        size: options.loadingIconSize || 70,
      };

      this.processingIconSettings = {
        color:'white', 
        size: options.loadingIconSize || 70,
        valueAdapter: function(x) { return 50; },
        rotation: true

      };

      if (this.assetPrecursor) {
        this.listenTo(this.assetPrecursor, 'progress', function(newPercent){
          this.percent = newPercent;
          this.render();
        });
        this.listenTo(this.assetPrecursor, 'processing-begun', function() {
          this.processing = true;
          this.render();
        });

        this.listenTo(this.assetPrecursor, 'processing-failed upload-failed', function() {
          this.stopListening(this.assetPrecursor, 'progress processing-begun');
          this.renderAsError();
        });
      }

      this.listenTo(this.model, 'error', function() {
        this.model.error = true; // A little hacky
        this.renderAsError();
      });

      this.listenTo(this.model, 'change', this.render);

      this.listenTo(this.model, 'edit:start', function() {
        this.editing = true;
        this.renderEditing();
      });
      this.listenTo(this.model, 'edit:end', function() {
        this.editing = false;
        this.renderEditing();
      });

      this._renderOnce = false;
    },
    
    renderEditing: function() {
      if (this.editing) {
        this.$el.addClass('currently-editing');
      } else {
        this.$el.removeClass('currently-editing');
      }

    },

    render: function() {

      var me = this;

      if (!this._renderOnce) {

        this.$el.html(this.template({ 
          media_type: this.model.get('media_type')
        }));

        this.$el.css({ 'text-align': 'center' });

        this.$('.loading')
          .setupProgressPie(this.progressIconSettings);
        this.$('.processing')
          .progressPie(this.processingIconSettings);

        if (this.assetPrecursor && 
            this.assetPrecursor.canMakeThumbnail() &&
            this.assetPrecursor.getFileSize() < 3000000) { // Only make thumbnails for images smaller than ~3mb

          this.assetPrecursor.thumbnailReady.done(function(src) {
            loadFittedImage({
              container: me.$('.thumb'),
              imageSrc: src
            });

          });
        }

        this._renderOnce = true;
      }

      if (this.model.error) {
        this.renderAsError();

      } else {
        if (this.model.id) {
          this.renderAsUploaded();
        } else {
          this.renderAsUploading();
        }

        this.renderEditing();

        this.$('.failed').hide();

      }

      return this;
    },

    renderAsUploading: function() {
      if (this.processing) {
        this.$('.processing').show();
        this.$('.loading').hide();

      } else {
        this.$('.processing').show();
        this.$('.loading').show()
                          .attr('data-val', this.percent)
                          .progressPie();

      }
      this.$('.completed').hide();
    },

    renderAsUploaded: function() {
      this.$('.loading').hide();
      this.$('.processing').hide();
      this.$('.completed').show();
    },

    renderAsError: function() {
      this.$('.loading').hide();
      this.$('.processing').hide();
      this.$('.completed').hide();
      this.$('.failed').show();     
    },

    handleEdit: function() {
      if (this.clickTriggersEdit) {
        this.model.trigger('edit:start', this.model);
      }
    }

    
  });

}());